import React, { useCallback, useState } from 'react'
import shortid from 'shortid'

import { BeaconDialog, mapBeaconForDisplay } from './Beacon'

export const useTrigger = (type) => {
  const [isOpen, setIsOpen] = useState(false)
  const [trigger, setTrigger] = useState({ type })

  const hide = () => setIsOpen(false)

  const TriggerDialog = useCallback(
    ({ canEdit, onSave }) => {
      if (!isOpen || !trigger) return null
      return (
        <div className='spectrum-Underlay is-open'>
          {trigger.type === 'beacon' && (
            <BeaconDialog trigger={trigger} onSave={onSave} onClose={hide} canEdit={canEdit} />
          )}
        </div>
      )
    },
    [isOpen, trigger]
  )

  const openDialog = (param) => {
    if (!param) {
      return null
    } else {
      // if param is a string, then treat it as type, otherwise expect object with `type` property
      let trigger = typeof param === 'string' ? { type: param } : param

      // assign random id if no id is present, eg. beacon-Ym5P
      if (!trigger.id) {
        trigger.id = `${trigger.type}-${trigger.id || shortid()}`
      }

      setTrigger(trigger)
      setIsOpen(true)
    }
  }

  const mapTriggerForDisplay = (param) => {
    const t = param || trigger
    switch (t.type) {
      case 'beacon':
        return mapBeaconForDisplay(t)
      default:
        return { id: t.id, type: t.type, setup: '', effects: '' }
    }
  }

  return { TriggerDialog, mapTriggerForDisplay, openDialog }
}
